import { render, staticRenderFns } from "./student-detail.vue?vue&type=template&id=24596695&scoped=true"
import script from "./student-detail.vue?vue&type=script&lang=js"
export * from "./student-detail.vue?vue&type=script&lang=js"
import style0 from "./student-detail.vue?vue&type=style&index=0&id=24596695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24596695",
  null
  
)

export default component.exports